'use strict'

import Cookies from 'js-cookie'
const domain = process.env.DOMAIN

class TokenManager {
  constructor () {
    this.token = Cookies.get('crmtoken', { domain })
    if (!this.token) {
      this.token = Cookies.get('token', { domain })
      Cookies.set('crmtoken', this.token, { expires: 0.5, domain })
    }
  }

  get token () {
    return this._token
  }

  set token (token) {
    this._token = token
  }

  logout () {
    this.token = null
    Cookies.remove('token', { domain })
    Cookies.remove('crmtoken', { domain })
  }

  fake (token) {
    Cookies.set('token', token, { expires: 0.5, domain })
  }
}

const tokenManager = new TokenManager()

export default tokenManager



// WEBPACK FOOTER //
// ./src/services/tokenManager.js